
export default {
  code: "da",
  week: {
    dow: 1, // Monday is the first day of the week.
    doy: 4  // The week that contains Jan 4th is the first week of the year.
  },
  buttonText: {
    prev: "Forrige",
    next: "Næste",
    today: "Idag",
    month: "Måned",
    week: "Uge",
    day: "Dag",
    list: "Agenda"
  },
  weekLabel: "Uge",
  allDayText: "Hele dagen",
  eventLimitText: "flere",
  noEventsMessage: "Ingen arrangementer at vise"
};
